export default __webpack_public_path__ + "static/media/logoInglesTec.99de4144.png";